import {
  Get_Languages,
  Get_Lead_Sources,
  Get_Preferred_Contact,
  Get_Statuses,
  Get_System_Users,
  Get_Users,
} from "@/modules/crm/leads/graphql-queries/general-queries";
import { Get_Tag_Colors, Get_Tags } from "../leads/graphql-queries/leadTag";
import {
  Get_Business_Categories,
  Get_Industries,
  Get_Template_Categories,
  Get_Workflows_Options,
} from "../automation/graphql-queries";
import { Get_Countries, Get_States } from "@/services/graph-ql/queries";
import {
  Get_Task_Priorities,
  Get_Task_Statuses,
  Get_Task_Types,
} from "../leads/graphql-queries/task-settings";

/** @name: @dropdownOptionsQueries
 *  @params: params which required by gql queries
 *  @description: define queries to fetch data
 */
const dropdownOptionsQueries = (params) => {
  const { companyId, searchText } = params;
  return [
    {
      query: Get_Statuses,
      key: "leadStatuses",
    },
    {
      query: Get_Lead_Sources,
      key: "leadSources",
      params: { order: { sortOrder: "ASC" } },
    },
    {
      query: Get_Users,
      key: "users",
      params: {
        companyId,
        searchText: "",
      },
    },
    {
      query: Get_System_Users,
      key: "systemUsers",
      subKey: "items",
    },
    {
      query: Get_Languages,
      key: "languages",
      params: {
        searchText,
      },
    },
    {
      query: Get_Preferred_Contact,
      key: "preferredContact",
    },
    {
      query: Get_Tags,
      key: "tags",
      subKey: "items",
    },
    {
      query: Get_Tag_Colors,
      key: "tagColors",
      subKey: "items",
    },
    {
      query: Get_Business_Categories,
      key: "businessCategory",
      subKey: "items",
      params: { order: { name: "ASC" }, skip: 0, take: 50 },
    },
    {
      query: Get_Template_Categories,
      key: "wfTemplateCategories",
      subKey: "items",
    },
    {
      query: Get_Industries,
      key: "industries",
      subKey: "",
    },
    {
      query: Get_Industries,
      key: "industries",
      subKey: "",
    },
    {
      query: Get_Workflows_Options,
      key: "workFlows",
      subKey: "items",
      params: {
        order: { id: "DESC" },
        where: {
          workflowRunStatus: {
            eq: 2,
          },
        },
        skip: 0,
        take: 100,
      },
    },
    {
      query: Get_Countries,
      key: "countries",
      subKey: "",
    },
    {
      query: Get_States,
      key: "statesProvinces",
      subKey: "",
    },
    {
      query: Get_Task_Statuses,
      params: { order: { sortOrder: "ASC" }, skip: 0, take: 50 },
      key: "taskStatuses",
      subKey: "items",
    },
    {
      query: Get_Task_Priorities,
      key: "taskPriorities",
      subKey: "items",
      params: { order: { id: "DESC" }, skip: 0, take: 50 },
    },
    {
      query: Get_Task_Types,
      key: "taskTypes",
      subKey: "items",
      params: { order: { id: "DESC" }, skip: 0, take: 50 },
    },
  ];
};

export default dropdownOptionsQueries;
